import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/collapse/index.js
// module id = 1368
// module chunks = 0